import { useCallback } from 'react';
import { Box, Drawer, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { IconSparkles, IconX } from '@tabler/icons-react';
import { useDesignWorkspace } from '@shared/designVariants/DesignWorkspaceProvider';
import { AskWorkspace } from './AskWorkspace';

/** Independent from routed/module editors. Hiding the dock retains its conversation and inputs. */
export const GlobalAskDock = () => {
  const workspace = useDesignWorkspace();
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up('lg'));
  const ignoreDirty = useCallback(() => {}, []);
  if (!workspace.assistantVisited) return null;
  const content = (
    <Stack sx={{ height: '100%', minHeight: 0, bgcolor: 'background.paper' }}>
      <Stack
        direction="row"
        gap={1}
        alignItems="center"
        sx={{ p: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}>
        <IconSparkles size={20} />
        <Typography component="h2" variant="h6" sx={{ flex: 1 }}>
          Ask Callevate
        </Typography>
        <IconButton aria-label="Hide Ask Callevate" onClick={workspace.closeAssistant}>
          <IconX size={19} />
        </IconButton>
      </Stack>
      <Box sx={{ p: 2, overflowY: 'auto', minHeight: 0, flex: 1 }}>
        <AskWorkspace
          onDirtyChange={ignoreDirty}
          writesBlocked={workspace.underlyingDirty}
          pageContext={workspace.pageContext}
        />
      </Box>
    </Stack>
  );
  return desktop ? (
    <Box
      component="aside"
      aria-label="Ask Callevate assistant dock"
      hidden={!workspace.assistantOpen}
      sx={{
        display: workspace.assistantOpen ? 'block' : 'none',
        flex: '0 0 420px',
        width: 420,
        height: '100%',
        minHeight: 0,
        borderInlineStart: 1,
        borderColor: 'divider',
      }}>
      {content}
    </Box>
  ) : (
    <Drawer
      open={workspace.assistantOpen}
      anchor={theme.direction === 'rtl' ? 'left' : 'right'}
      onClose={workspace.closeAssistant}
      ModalProps={{ keepMounted: true }}
      PaperProps={{
        role: 'dialog',
        'aria-label': 'Ask Callevate assistant dock',
        sx: { width: { xs: '100%', sm: 460 }, maxWidth: '100vw' },
      }}>
      {content}
    </Drawer>
  );
};
